import selectors from '../../rootSelectors';
import { TRO, VOCAB, SPELLING, TRC, WR, LC } from '../../constants/measure';
import {
    goToQuestion,
    goToBookStart,
    goToReading,
    goToInstructions,
} from '../navigation/navigationActions';
import { STATUS } from '../../constants/result';
import * as page from '../../constants/assessmentItemType';
import VocaboServiceClient from '../clients/VocaboServiceClient';
import { showHelpPopup } from '../screen/screenActions';

const resumeTRC = (nextItem, state) => dispatch => {
    const hasUnscoredUntranscribableResult = selectors.getHasUnscoredUntranscribableResult(state);
    const hasUnscoredUnknownErrorResult = selectors.getHasUnscoredUnknownErrorResult(state);
    if (hasUnscoredUnknownErrorResult || hasUnscoredUntranscribableResult) {
        dispatch(showHelpPopup());
        return;
    }
    if (nextItem === page.BOOK) {
        dispatch(goToBookStart(TRC));
    } else if (nextItem === page.COMPREHENSION) {
        dispatch(goToQuestion(TRC, null, 1));
    } else if (nextItem === page.INSTRUCTIONS) {
        dispatch(goToInstructions(TRC));
    }
};

const resumeLC = nextItem => dispatch => {
    if (nextItem === page.READING) dispatch(goToReading(LC.ASSESSMENT));
    if (nextItem === page.COMPREHENSION) dispatch(goToQuestion(LC.ASSESSMENT, null, 1));
};

const resumeVocab = (measure, state) => {
    const nextItem = selectors.getNextResultItem(state, { measure, isComplete: false });

    return dispatch => {
        dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB[measure], nextItem));
    };
};

const resumeSpelling = nextItem => dispatch => {
    dispatch(goToQuestion(SPELLING.ASSESSMENT, null, nextItem));
};

const resumeWordReading = (measure, state) => dispatch => {
    const nextItem = selectors.getNextResultItem(state, { measure: WR.MEASURE, isComplete: false });

    return dispatch(goToQuestion(WR.KEY, null, nextItem));
};

const resumeAssessmentByMeasure = {
    [TRO.MEASURE](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state, {
            measure: TRO.MEASURE,
            isComplete: false,
        });
        return dispatch => {
            dispatch(resumeTRC(nextItem, state));
        };
    },

    [LC.MEASURE](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state, {
            measure: LC.MEASURE,
            isComplete: false,
        });
        return dispatch => {
            dispatch(resumeLC(nextItem));
        };
    },

    [WR.MEASURE](measure, measureType, state) {
        return dispatch => {
            dispatch(resumeWordReading(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.TQVM](measure, measureType, state) {
        return dispatch => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.FITB](measure, measureType, state) {
        return dispatch => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.BD](measure, measureType, state) {
        return dispatch => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [SPELLING.MEASURE_API_KEY](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state, { measure, isComplete: false });
        return dispatch => {
            dispatch(resumeSpelling(nextItem));
        };
    },
};

export const resumeAssessment = ({ measure, measureType, status }) => (dispatch, getStore) => {
    if (status !== STATUS.IN_PROGRESS) return;
    const state = getStore();
    dispatch(resumeAssessmentByMeasure[measure](measure, measureType, state));
};
